import PropTypes from 'prop-types';
import './LoadStatus.css';

// 데이터를 불러오는 중이거나 실패했을 때의 안내. 실패하면 다시 시도 버튼을 보여준다.
export default function LoadStatus({ error, onRetry }) {
    if (!error) return <p className="admin-load-status" role="status">불러오고 있습니다.</p>;
    return (
        <div className="admin-load-status error" role="alert">
            <p>{error}</p>
            <button type="button" onClick={onRetry}>다시 시도</button>
        </div>
    );
}

LoadStatus.propTypes = {
    error: PropTypes.string,
    onRetry: PropTypes.func.isRequired,
};
